import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';
import PropTypes from 'prop-types';
import { isEmpty, get, getOr, every } from 'lodash/fp';
import { Grid, Row, Col, Icon, Input, DateRangePicker, Button } from 'rsuite';
import { fetchBlob } from '../../../services/fbm-api/api-request';
import { formatDateRange } from '../../../helpers/dates';
import triggerBlobDownload from '../../../helpers/triggerBlobDownload';
import ExportButton from '../ExportButton';

const EventSearch = ({
  searchQuery,
  queryOptions,
  placeholder,
  onChange,
  onSubmit,
  onClear,
  onInit,
  isFetching
}) => {
  useEffect(onInit, []);
  const [isExporting, setIsExporting] = useState(false);

  const handleOnChangeQuery = q => {
    onChange({ ...searchQuery, q });
  };
  const handleOnChangeOutreachOn = outreachOn => {
    onChange({ ...searchQuery, outreachOn });
  };

  const handleExport = async () => {
    setIsExporting(true);
    const outreachOn = get('outreachOn', searchQuery);
    const qs = outreachOn
      ? { ...searchQuery, outreachOn: formatDateRange(outreachOn) }
      : searchQuery;
    try {
      const blob = await fetchBlob('outreaches/exports/upcoming', { qs });
      const dateTime = moment().format('MM-DD-YYYY');
      const filename = `upcoming-events-${dateTime}.csv`;
      triggerBlobDownload(blob, filename);
    } catch (err) {
      toastr.error('Error', getOr('Server error', 'message', err));
    } finally {
      setIsExporting(false);
    }
  };

  const hasQuery = !every(isEmpty, searchQuery);
  return (
    <Grid fluid style={{ padding: 0, marginLeft: 0 }}>
      <Row gutter={8}>
        <Col xs={6}>
          <Input
            value={getOr('', 'q', queryOptions)}
            onChange={handleOnChangeQuery}
            style={{ paddingLeft: 10 }}
            placeholder={placeholder}
            onKeyPress={({ key }) => {
              if (key === 'Enter') onSubmit(queryOptions);
            }}
          />
        </Col>

        <Col xs={5}>
          <DateRangePicker
            style={{ width: '100%' }}
            value={getOr([], 'outreachOn', queryOptions)}
            placeholder="Select date range"
            onChange={handleOnChangeOutreachOn}
          />
        </Col>
        <Col xs={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Button
            color="green"
            style={{ borderBottom: 'none', marginRight: 10 }}
            disabled={!hasQuery || isFetching}
            onClick={() => onSubmit(queryOptions)}
          >
            <Icon icon="search" /> Search
          </Button>
          <Button
            style={{ borderBottom: 'none', marginRight: 10 }}
            disabled={isFetching}
            onClick={onClear}
          >
            <Icon icon="refresh" /> Reset
          </Button>
          <ExportButton onClick={handleExport} isLoading={isExporting} />
        </Col>
      </Row>
    </Grid>
  );
};

const SearchQueryType = PropTypes.shape({
  q: PropTypes.string,
  outreachOn: PropTypes.arrayOf(PropTypes.shape({}))
});

EventSearch.propTypes = {
  placeholder: PropTypes.string.isRequired,
  searchQuery: SearchQueryType,
  queryOptions: SearchQueryType,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onInit: PropTypes.func,
  isFetching: PropTypes.bool.isRequired
};

EventSearch.defaultProps = {
  searchQuery: {},
  queryOptions: {},
  onInit: () => {}
};

export default EventSearch;
